import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
  apiCall, formattedPrice,
  getBranches,
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import { setIncomeExpenseChartData, setIncomeExpensePieChartData } from "../../actions";
import IncomeExpenseDataChart from "../../components/Charts/IncomeExpenseDataChart";
import IncomeExpenseByCategoriesPieChart from "../../components/Charts/IncomeExpenseByCategoriesPieChart";
import './IncomeExpenseReports.css';

class FinanceReports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      totals: [],
      incomeExpenseData: [],
      incomeExpensePieData: [],
      branches: [],
      formData: {
        startDateTime: '',
        endDateTime: '',
        by_branch: '',
      },
      loading: false,
      isLoad: true,

    }
  }
  componentDidMount() {
    this.getReports();
    /*const now = new Date();
    const localDateTime = new Date(now.getTime() - (now.getTimezoneOffset() * 60000))
        .toISOString()
        .slice(0, 16);
    this.setState( prevState => ({
        formData : {
          ...prevState.formData,
          startDateTime:localDateTime
        }
    }));*/
  }
  getReports = async () => {

    try {
      const response = await apiCall('business/reports/income-expense', 'post', null);
      const branches = await getBranches();
      this.setState({
        totals: response.totals,
        incomeExpenseData: response.incomeExpenseReport,
        incomeExpensePieData: response.byCategories,
        branches
      }, () => {
        this.props.setIncomeExpenseChartData(response.incomeExpenseReport);
        this.props.setIncomeExpensePieChartData(response.byCategories);
        this.setState({ isLoad: false });
      });

    }
    catch (e) {
      this.setState({ isLoad: false });
      console.log(e);
    }
  }

  handleChange = (e) => {
    const { id, value } = e.target;
    const formData = { ...this.state.formData };
    formData[id] = value;
    this.setState({ formData });
  };
  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ loading: true });
    const { formData } = this.state;
    const reportFormData = new FormData();
    Object.keys(formData).forEach(key => {
      reportFormData.append(key, formData[key]);
    });
    try {
      const response = await apiCall('business/reports/income-expense', 'post', reportFormData);
      this.setState({
        totals: response.totals,
        incomeExpenseData: response.incomeExpenseReport,
        incomeExpensePieData: response.byCategories,
      }, () => {
        this.props.setIncomeExpenseChartData(response.incomeExpenseReport);
        this.props.setIncomeExpensePieChartData(response.byCategories);
        this.setState({ isLoad: false });
      });
      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState({ loading: false });
    }

  }
  render() {
    const {
      loading,
      isLoad,
      branches,
      totals,
      incomeExpenseData,
      incomeExpensePieData
    } = this.state;


    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Gelir ve Gider Raporları"
              Breadcrumb={[
                { name: "Raporlar", navigate: "" },
                { name: "Finans", navigate: "" },
                { name: "Gelir ve Gider Raporları", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <form onSubmit={this.handleSubmit}>
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="startDateTime" className="font-weight-bold text-cyan">
                              Başlangıç Tarihi
                            </label>
                            <input
                              id="startDateTime"
                              className="form-control"
                              type="datetime-local"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="endDateTime" className="font-weight-bold text-cyan">
                              Bitiş Tarihi
                            </label>
                            <input
                              id="endDateTime"
                              className="form-control"
                              type="datetime-local"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="by_branch" className="font-weight-bold text-cyan">
                              Şube
                            </label>
                            <select name="by_branch" id="by_branch" className="form-control"
                              onChange={this.handleChange}>
                              <option value="">Seçiniz</option>
                              {branches && branches.map((branch) => (
                                <option key={branch.id} value={branch.id}>
                                  {branch.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="body">
                      <div className="col-lg-12 d-flex justify-content-center">
                        <div className="col-lg-4">
                          <div className="form-group">
                            {loading ? (
                              <button className="btn btn-outline-primary btn-sm btn-block" disabled={true}
                                style={{ textAlign: "-webkit-center" }}>
                                Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                  color="#268bd2"></ReactLoading>
                              </button>
                            ) :
                              <button className="btn btn-outline-primary btn-sm btn-block"
                                type="submit">
                                Güncelle
                              </button>}
                          </div>
                        </div>
                      </div>

                    </div>
                  </form>

                  {/* Modern Income Expense Statistics Cards */}
                  <div className="body modern-income-expense-stats-section">
                    <div className="row clearfix">
                      {/* Total Income Card */}
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="modern-income-expense-stat-card card-green">
                          <div className="stat-icon-wrapper">
                            <i className="fa fa-plus-circle" style={{ fontSize: '3rem', color: '#27ae60' }}></i>
                          </div>
                          <div className="stat-content">
                            <h3 className="stat-title">Toplam Gelir</h3>
                            <div className="stat-value">{totals.totalIncome || 0}</div>
                            <div className="stat-amount">{formattedPrice(totals.totalIncomeAmount || 0)}</div>
                            <p className="stat-subtitle">Manuel gelir kayıtları</p>
                          </div>
                        </div>
                      </div>

                      {/* Total Expense Card */}
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="modern-income-expense-stat-card card-red">
                          <div className="stat-icon-wrapper">
                            <i className="fa fa-minus-circle" style={{ fontSize: '3rem', color: '#e74c3c' }}></i>
                          </div>
                          <div className="stat-content">
                            <h3 className="stat-title">Toplam Gider</h3>
                            <div className="stat-value">{totals.totalExpense || 0}</div>
                            <div className="stat-amount">{formattedPrice(totals.totalExpenseAmount || 0)}</div>
                            <p className="stat-subtitle">Manuel gider kayıtları</p>
                          </div>
                        </div>
                      </div>

                      {/* Balance Card */}
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className={`modern-income-expense-stat-card ${totals.difference >= 0 ? 'card-blue' : 'card-orange'}`}>
                          <div className="stat-icon-wrapper">
                            <i className={`fa ${totals.difference >= 0 ? 'fa-check-circle' : 'fa-exclamation-circle'}`}
                              style={{ fontSize: '3rem', color: totals.difference >= 0 ? '#3498db' : '#f39c12' }}></i>
                          </div>
                          <div className="stat-content">
                            <h3 className="stat-title">Kalan Tutar</h3>
                            <div className="stat-amount large">{formattedPrice(totals.difference || 0)}</div>
                            <p className="stat-subtitle">
                              {totals.difference >= 0 ? '✓ Pozitif bakiye' : '⚠ Negatif bakiye'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="body">
                    <div className="row clearfix">
                      <div className="col-lg-6 col-md-12">
                        <div className="card">
                          <div className="header">
                            <h2>Aylık Gelir ve Gider Grafiği</h2>
                          </div>
                          {!isLoad ? (
                            incomeExpenseData && Object.keys(incomeExpenseData).length > 0 ? (
                              <IncomeExpenseDataChart></IncomeExpenseDataChart>
                            ) : (
                              <div className="alert alert-warning text-center">Veri yok</div>
                            )

                          ) : ""}
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <div className="card">
                          <div className="header">
                            <h2>Kategori Bazlı Gelir ve Giderler</h2>
                          </div>
                          {!isLoad ? (
                            incomeExpensePieData && Object.keys(incomeExpensePieData).length > 0 ? (
                              <IncomeExpenseByCategoriesPieChart></IncomeExpenseByCategoriesPieChart>
                            ) : (
                              <div className="alert alert-warning text-center">Veri yok</div>
                            )

                          ) : ""}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ analyticalReducer }) => ({
  incomeExpenseChartData: analyticalReducer.incomeExpenseChartData,
  incomeExpensePieChartData: analyticalReducer.incomeExpensePieChartData,
});

export default withPermissions(withRouter(connect(mapStateToProps, {
  setIncomeExpenseChartData, setIncomeExpensePieChartData
})(FinanceReports)));
